/* global WOW */

new WOW().init();

setTimeout(() => {
  const fBackgroundID = document.querySelector('#fBackground');
  fBackgroundID.classList.add('active');
}, 1500);
